import { getProfileFilterSlice } from '@/feature/patients/components/patient-list/profileFilter';
import type { ProfileFilterState } from '@/feature/patients/types';
import type { EfaxSearchState } from '../types';
import {
  getOutputCategoryFilterSlice,
  isSameOutputCategoryFilter,
} from './outputCategoryFilter';

const SCALAR_SEARCH_KEYS = [
  'documentName',
  'documentId',
  'receivedAtStart',
  'receivedAtEnd',
  'documentStatus',
  'outputFileName',
  'patientName',
  'patientDob',
  'patientReferenceId',
  'patientKey',
  'providerName',
  'providerFacilityName',
  'providerType',
  'receivingProviderName',
  'receivingProviderFacilityName',
  'receivingProviderType',
] as const satisfies ReadonlyArray<keyof EfaxSearchState>;

// compare two sets of IDs, for profiles
const isSameIdSet = (prevIds: string[], currentIds: string[]) =>
  prevIds.length === currentIds.length &&
  prevIds.every((id) => currentIds.includes(id));

const isSameProfileFilter = (
  prev: ProfileFilterState,
  current: ProfileFilterState,
) => {
  if (
    prev.profileFilterMode === 'exclude' &&
    current.profileFilterMode === 'exclude'
  ) {
    return isSameIdSet(
      prev.excludeOrganizationProfileIds,
      current.excludeOrganizationProfileIds,
    );
  }

  if (
    prev.profileFilterMode === 'include' &&
    current.profileFilterMode === 'include'
  ) {
    return isSameIdSet(
      prev.organizationProfileIds,
      current.organizationProfileIds,
    );
  }

  return false;
};

export const isSameEfaxSearch = (
  prev: EfaxSearchState,
  current: EfaxSearchState,
) => {
  const scalarsMatch = SCALAR_SEARCH_KEYS.every((key) => {
    const prevValue = prev[key];
    const currentValue = current[key];

    if (prevValue instanceof Date && currentValue instanceof Date) {
      return prevValue.getTime() === currentValue.getTime();
    }

    return prevValue === currentValue;
  });

  if (!scalarsMatch) {
    return false;
  }

  if (
    !isSameProfileFilter(
      getProfileFilterSlice(prev),
      getProfileFilterSlice(current),
    )
  ) {
    return false;
  }

  return isSameOutputCategoryFilter(
    getOutputCategoryFilterSlice(prev),
    getOutputCategoryFilterSlice(current),
  );
};
